export const SESSION_ID = 649;

export const BEHAVIORAL_CODES = [
  {
    id: 'implementing',
    label: 'Implementing',
    description: 'Actively writing new code',
    color: '#10b981', // green
  },
  {
    id: 'debugging',
    label: 'Debugging',
    description: 'Editing code to fix an error or issue',
    color: '#ef4444', // red
  },
  {
    id: 'seekingHelp',
    label: 'Seeking Help',
    description: 'Typing a query',
    color: '#8b5cf6', // purple
  },
  {
    id: 'thinking',
    label: 'Thinking',
    description: 'Reading, pausing, or planning',
    color: '#06b6d4', // cyan
    subcategories: [
      { id: 'thinking-task', label: 'Task/Problem' },
      { id: 'thinking-code', label: 'Code' },
      { id: 'thinking-error', label: 'Error' },
      { id: 'thinking-pre-query', label: 'Asking LLM' },
      { id: 'thinking-llm', label: 'LLM Response' },
    ],
  },
  {
    id: 'idle',
    label: 'Idle',
    description: 'No activity detected',
    color: '#fbbf24', // amber
  },
  {
    id: 'offTopic',
    label: 'Off-Topic',
    description: 'Messing around or testing the system',
    color: '#f97316', // orange
  },
  {
    id: 'unknown',
    label: 'Unknown/Other',
    description: "Unable to classify or doesn't fit any category",
    color: '#94a3b8', // slate gray
  },
];